import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Demo, Redesign } from './views';
import { RoutesURL } from './constants/routes';

type MyProps = {
    responsive: boolean;
};

type MyState = {};

export class AppRouter extends Component<MyProps, MyState> {
    render() {
        return (
            <React.Fragment>
                <Box
                    width="100%"
                    height="100%"
                    minHeight={[
                        '-moz-fill-available',
                        '-webkit-fill-available',
                        'fill-available',
                    ]}
                    position="fixed"
                >
                    <Routes>
                        <Route
                            index
                            element={
                                <Redesign responsive={this.props.responsive} />
                            }
                        />
                        <Route path={RoutesURL.dashboard} element={<Demo />} />
                        <Route path={RoutesURL.demo} element={<Demo />} />
                        <Route
                            path={RoutesURL.redesign}
                            element={
                                <Redesign responsive={this.props.responsive} />
                            }
                        />
                        <Route path={RoutesURL.bartaco} element={<Demo />} />
                        <Route
                            path={RoutesURL.notFound}
                            element={<Navigate replace to={RoutesURL.demo} />}
                        />
                    </Routes>
                </Box>
            </React.Fragment>
        );
    }
}
